function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.32 11.68C5.20366 11.68 5.92 10.9637 5.92 10.08C5.92 9.19634 5.20366 8.48 4.32 8.48C3.43634 8.48 2.72 9.19634 2.72 10.08C2.72 10.9637 3.43634 11.68 4.32 11.68ZM4.32 10.96C4.80601 10.96 5.2 10.566 5.2 10.08C5.2 9.59399 4.80601 9.2 4.32 9.2C3.83399 9.2 3.44 9.59399 3.44 10.08C3.44 10.566 3.83399 10.96 4.32 10.96Z",
  fill: "current"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.04 10.08C7.04 11.5822 5.82221 12.8 4.32 12.8C2.81779 12.8 1.6 11.5822 1.6 10.08C1.6 8.57779 2.81779 7.36 4.32 7.36C5.82221 7.36 7.04 8.57779 7.04 10.08ZM6.32 10.08C6.32 11.1846 5.42457 12.08 4.32 12.08C3.21543 12.08 2.32 11.1846 2.32 10.08C2.32 8.97543 3.21543 8.08 4.32 8.08C5.42457 8.08 6.32 8.97543 6.32 10.08Z",
  fill: "current"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.28 4.16C5.28 4.69019 4.85019 5.12 4.32 5.12C3.78981 5.12 3.36 4.69019 3.36 4.16C3.36 3.62981 3.78981 3.2 4.32 3.2C4.85019 3.2 5.28 3.62981 5.28 4.16ZM4.56 4.16C4.56 4.29255 4.45255 4.4 4.32 4.4C4.18745 4.4 4.08 4.29255 4.08 4.16C4.08 4.02745 4.18745 3.92 4.32 3.92C4.45255 3.92 4.56 4.02745 4.56 4.16Z",
  fill: "current"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 1.12C0 0.501441 0.501441 0 1.12 0H7.52C8.13856 0 8.64 0.501441 8.64 1.12V14.88C8.64 15.4986 8.13856 16 7.52 16H1.12C0.501441 16 0 15.4986 0 14.88V1.12ZM1.12 0.72H7.52C7.74091 0.72 7.92 0.899086 7.92 1.12V14.88C7.92 15.1009 7.74091 15.28 7.52 15.28H1.12C0.899086 15.28 0.72 15.1009 0.72 14.88V1.12C0.72 0.899086 0.899086 0.72 1.12 0.72Z",
  fill: "current"
});

function SvgDoorbell(_ref, svgRef) {
  let title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorbell);
export default __webpack_public_path__ + "static/media/doorbell.f2052f55.svg";
export { ForwardRef as ReactComponent };